import { buildModelManager } from "../builder.js";
const DefaultAttendanceUserIpProfileSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  eventCount: true,
  firstSeenAt: true,
  forwardedIp: true,
  institution: true,
  ipAddress: true,
  lastEventId: true,
  lastSeenAt: true,
  sourceModes: true,
  updatedAt: true,
  userAgents: true,
  userId: true
};
const modelApiIdentifier = "attendanceUserIpProfile";
const pluralModelApiIdentifier = "attendanceUserIpProfiles";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAttendanceUserIpProfileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAttendanceUserIpProfileSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceUserIpProfileSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceUserIpProfileSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceUserIpProfileSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceUserIpProfileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceUserIpProfileSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "attendanceUserIpProfileGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AttendanceUserIpProfileManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAttendanceUserIpProfileSelection,
  operations
);
export {
  AttendanceUserIpProfileManager,
  DefaultAttendanceUserIpProfileSelection
};
//# sourceMappingURL=AttendanceUserIpProfile.js.map
